<div class="container section-gap">
  <div class="row circle-line-graph-container">
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <div class="row chart" #panel>
        <kla-circle-line-chart class="center-circle" *ngIf="showChart" id="{{chartConfig.id}}"
                               [titleContainer]="titleContainer" [titleConfig]="config.title" [config]="chartConfig"
                               [width]="chartConfig.width "></kla-circle-line-chart>
      </div>
    </div>

    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title (titleContainerLoaded)="titleContainer = $event" [lineConfig]="lineConfig"
                 [config]="config.title" [showFooter]="false"></kla-title>
    </div>
  </div>
</div>
